import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-landing-quick-start',
  templateUrl: './landing-quick-start.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-quick-start.component.scss']
})
export class LandingQuickStartComponent implements OnInit {

  lightboxOpen = false;
  lightboxSrc = '';
  lightboxAlt = '';

  constructor(private router: Router, private title: Title, private meta: Meta, @Inject(DOCUMENT) private doc: Document) {}

  ngOnInit(): void {
    const CANON = 'https://geoastra.com';
    const url = `${CANON}/landing-quick-start`;
    this.title.setTitle('Quick Start — GeoAstra NTRIP Caster');
    this.meta.updateTag({ name: 'description', content: 'Step-by-step Quick Start for GeoAstra NTRIP Caster: connect RTK base, create mount points, and start streaming.' });
    this.meta.updateTag({ property: 'og:title', content: 'Quick Start — GeoAstra NTRIP Caster' });
    this.meta.updateTag({ property: 'og:description', content: 'Connect RTK base and start streaming in minutes.' });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:type', content: 'article' });
    this.meta.updateTag({ property: 'og:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    this.meta.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ name: 'twitter:title', content: 'Quick Start — GeoAstra' });
    this.meta.updateTag({ name: 'twitter:description', content: 'Step-by-step guide to use GeoAstra NTRIP Caster.' });
    this.meta.updateTag({ name: 'twitter:image', content: 'https://geoastra.com/assets/images/landing/GeoAstra_NTRIP.png' });
    let link: HTMLLinkElement | null = this.doc.querySelector("link[rel='canonical']");
    if (!link) { link = this.doc.createElement('link'); link.setAttribute('rel', 'canonical'); this.doc.head.appendChild(link); }
    link.setAttribute('href', url);
  }

  goBack(): void { this.router.navigate(['/landing-ntrip-caster']); }

  openLightbox(src: string, alt: string): void {
    this.lightboxSrc = src;
    this.lightboxAlt = alt || '';
    this.lightboxOpen = true;
  }

  closeLightbox(): void {
    this.lightboxOpen = false;
    this.lightboxSrc = '';
    this.lightboxAlt = '';
  }
}
